import styled from "styled-components";

export const TableContainer = styled.div`
  padding: 3.2rem 3.6rem;
  .loading {
    text-align: center;
    font-size: 1.6rem;
    padding: 1.6rem;
    border: 1px solid #ebebeb;
    border-radius: 1.2rem;
  }
  .table-head-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 2rem;
    .left {
      .table-total-row {
        display: flex;
        align-items: center;
        font-size: 1.6rem;
        color: #555;
        font-weight: 500;
        input[type="checkbox"] {
          width: 1.6rem;
          height: 1.6rem;
        }
      }
    }
    .right {
      .btn-box {
        &.multi {
          display: flex;
          gap: 1.6rem;
          button {
            width: 15.4rem;
          }
        }
        button {
          background-color: #0e322b;
          padding: 1rem 2.4rem;
          color: white;
          border-radius: 0.6rem;
          font-size: 1.6rem;
          font-weight: 500;
          border: none;
          outline: none;
          cursor: pointer;
          opacity: 0.7;

          &:hover {
            opacity: 1;
          }
          &:active {
            transform: scale(0.98);
          }
          &.regist {
            background-color: #30a690;
          }
          &.modify {
            background-color: #2d2d2d;
          }
          &.delete {
            background-color: #ffab40;
          }
        }
      }
    }
  }
  .fixed-height {
    max-height: 55rem;
    overflow-x: auto;
  }
  table {
    width: 100%;
    thead {
      th {
        font-size: 1.5rem;
        color: #2d2d2d;
        background-color: #c1e4de;
        padding: 1.6rem;
        border-bottom: none;
        position: relative;
        span.up {
          display: inline-flex;
          margin-left: 1rem;
          transform: rotate(90deg) translateX(2px);
          img {
            display: flex;
            width: 0.8rem;
          }
        }
        span.down {
          display: inline-flex;
          margin-left: 1rem;
          transform: rotate(270deg) translateX(-2px);
          img {
            display: flex;
            width: 0.8rem;
          }
        }
      }
    }
    th,
    td {
      border-left: 1px solid #ebebeb;
      border-bottom: 1px solid #ebebeb;
    }
    th:first-child,
    td:first-child {
      border-left: none;
    }
    tbody {
      td {
        font-size: 1.5rem;
        font-weight: 400;
        text-align: center;
        padding: 1.8rem;
        color: #555;
        vertical-align: middle;
        input[type="checkbox"] {
          width: 1.6rem;
          height: 1.6rem;
        }
        &.type-folder {
          color: #2d2d2d;
        }
        .clickable-folder {
          color: #1847ed;
          text-decoration: underline;
          cursor: pointer;
        }
        .history-file-name {
          display: -webkit-box;
          min-height: 4.2rem;
          line-height: 2.1rem;
          overflow: hidden;
          text-align: left;
          word-break: break-all;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
        .download-btn {
          background-color: #0e322b;
          color: white;
          width: 15.4rem;
          padding: 0.9rem;
          border: none;
          outline: none;
          border-radius: 0.4rem;
          opacity: 0.7;
          &:hover {
            opacity: 1;
          }
          &:active {
            transform: scale(0.97);
          }
        }
        .worm-approve-btn {
          background-color: #30a690;
          color: white;
          width: 8.8rem;
          padding: 0.9rem;
          border: none;
          outline: none;
          border-radius: 0.4rem;
          opacity: 0.7;
          cursor: pointer;
          &:hover {
            opacity: 1;
          }
          &:active {
            transform: scale(0.97);
          }
          &:disabled {
            background-color: #eee;
            color: #555;
            opacity: 1;
            cursor: not-allowed;
            transform: none;
          }
        }
        .worm-request-btn {
          background-color: #30a690;
          color: white;
          width: 8.8rem;
          padding: 0.9rem;
          border: none;
          outline: none;
          border-radius: 0.4rem;
          opacity: 0.7;
          cursor: pointer;
          &:hover {
            opacity: 1;
          }
          &:active {
            transform: scale(0.97);
          }
        }
        .folder-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 2rem;
            display: flex;
            transform: translateY(-2px);
          }
          gap: 0.4rem;
        }
      }
    }
  }
  .worm-confirm-modal {
    .modal-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 2rem 2.4rem;
      border-bottom: 1px solid #ebebeb;
      h3 {
        font-size: 2rem;
        font-weight: 600;
        color: #222;
      }
      .closed-modal-btn {
        width: 3rem;
        height: 3rem;
        border: 0;
        background-color: transparent;
        color: #555;
        font-size: 2.4rem;
        line-height: 1;
        cursor: pointer;
      }
    }
    .modal-body {
      padding: 2.4rem;
      p {
        font-size: 1.6rem;
        line-height: 1.6;
        color: #333;
        word-break: keep-all;
      }
    }
    .modal-actions {
      display: flex;
      justify-content: flex-end;
      gap: 1rem;
      padding: 0 2.4rem 2.4rem;
      button {
        min-width: 8rem;
        height: 3.6rem;
        border: 0;
        border-radius: 0.6rem;
        color: white;
        font-size: 1.5rem;
        cursor: pointer;
        &.cancel {
          background-color: #9a9a9a;
        }
        &.confirm {
          background-color: #30a690;
        }
      }
    }
  }
  @media screen and (max-width: 768px) {
    padding: 2rem 1rem;
    form {
      width: 100%;
      overflow: hidden;
      .fixed-height {
        width: 100%; /* 부모 요소의 너비를 100%로 설정 */
        overflow-x: auto !important;
        -webkit-overflow-scrolling: touch !important; /* 터치스크린에서 스크롤이 부드럽게 보이도록 설정 */

        table {
          min-width: 1400px;
          width: 100%;
        }
      }
      .table-head-wrap.user-table {
        flex-direction: column;
        .left {
          .table-total-row {
            margin-bottom: 1rem;
          }
        }
        .right {
          .btn-box.multi {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            button {
              width: auto;
            }
          }
        }
      }
    }
  }
`;
